export default "__VITE_ASSET__4c973262__"